export const ONE_KIBIBYTE = 1024;
export const ONE_MEBIBYTE = ONE_KIBIBYTE ** 2;
export const ONE_GIBIBYTE = ONE_KIBIBYTE ** 3;
export const ONE_TEBIBYTE = ONE_KIBIBYTE ** 4;
export const ONE_PEBIBYTE = ONE_KIBIBYTE ** 5;
export const ONE_EXBIBYTE = ONE_KIBIBYTE ** 6;
export const ONE_KILOBYTE = 1000;
export const ONE_MEGABYTE = ONE_KILOBYTE ** 2;
export const ONE_GIGABYTE = ONE_KILOBYTE ** 3;
export const ONE_TERABYTE = ONE_KILOBYTE ** 4;
